const translationFunctionFormats = {
	LocalizedCurrency: '{{value, }}',
	netTotalCurrency: '{{value, NetTotal}}',
};

export default translationFunctionFormats;
